import React from 'react';
import { Col, Row } from 'reactstrap';
import styled, { css } from 'styled-components';
import { Button } from 'reactstrap'; // eslint-disable-next-line react/prop-types

var UnstyledCallout = function UnstyledCallout(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(Row, {
    className: className
  }, /*#__PURE__*/React.createElement(Col, null, children));
};

var Callout = styled(UnstyledCallout).withConfig({
  displayName: "Callout",
  componentId: "pjmfou-0"
})(["background-color:", ";border-radius:10px;margin-bottom:40px;padding:20px;", ""], function (props) {
  return props.color ? props.color : 'rgb(192, 196, 201)';
}, function (props) {
  return !props.fullWidth ? css(["margin-left:40px;margin-right:40px;"]) : null;
});
var CalloutText = styled.h4.withConfig({
  displayName: "Callout__CalloutText",
  componentId: "pjmfou-1"
})(["", ";float:left;margin-top:10px;"], function (props) {
  return props.color ? css(["color:", ""], props.color) : null;
});
var CalloutButton = styled(Button).attrs({
  color: function color(props) {
    return props.color || 'primary';
  },
  size: function size(props) {
    return props.size || 'lg';
  }
}).withConfig({
  displayName: "Callout__CalloutButton",
  componentId: "pjmfou-2"
})(["float:right;"]);
Callout.Button = CalloutButton;
Callout.Text = CalloutText;
export default Callout;